"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterIsPromoter = filterIsPromoter;
exports.levelFilter = levelFilter;
exports.typeFilter = typeFilter;
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

//会员过滤器

/**
 * 等级
 */
function levelFilter(status) {
  if (!status) {
    return '';
  }
  var arrayList = JSON.parse(localStorage.getItem('single-admin-levelKey'));
  var array = arrayList.filter(function (item) {
    return status === item.id;
  });
  if (array.length) {
    return array[0].name;
  } else {
    return '';
  }
}

/**
 * 用户类型
 */
function typeFilter(status) {
  var statusMap = {
    wechat: '微信用户',
    routine: '小程序用户',
    h5: 'H5用户'
  };
  return statusMap[status];
}

/**
 * 用户类型
 */
function filterIsPromoter(status) {
  var statusMap = {
    true: '推广员',
    false: '普通用户'
  };
  return statusMap[status];
}